import React from 'react'
import { icons } from '../../assets/icons'

const NavbarLoginBody = () => {
    return (
        <div className='d-flex justify-content-center mx-auto mt-4 mb-5'>
            <img
                src={icons.exactianLogoWhite}
                style={{ width: '60px', height: '60px' }}
                alt=""
            />
        </div>
    )
}

export default NavbarLoginBody